import coreRoutes from '@glittr/frontend-core/src/routes';
import Home from './views/pages/app/map/index.vue';

export default {
  mode: 'history',
  base: process.env!.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    ...coreRoutes,
    {
      path: '/:tenant/:workspace/fireDepartment/:fireDepartmentId',
      name: 'dashboard',
      component: () => import('./views/pages/app/map/index.vue'),
    },
    {
      path: '/:tenant/:workspace/fireDepartment',
      name: 'dashboard',
      component: () => import('./views/pages/app/map/index.vue'),
    },
    {
      path: '/:tenant/:workspace/admin/hydrants',
      name: 'admin-hydrants',
      component: () => import('./views/pages/app/hydrantsAdmin/list.vue'),
    },
    {
      path: '/:tenant/:workspace/admin/fireDepartment/:fireDepartmentId/hydrants/create',
      name: 'admin-hydrants-create',
      component: () => import('./views/pages/app/hydrantsAdmin/new.vue'),
    },
    {
      path: '/:tenant/:workspace/admin/fireDepartment/:fireDepartmentId/hydrants/:hydrantId/edit',
      name: 'admin-hydrants-edit',
      component: () => import('./views/pages/app/hydrantsAdmin/edit.vue'),
    },
  ],
};
